<template>
   <form @submit="Submit" v-if="(notSubmitted == true) ">

    <!-- {{this.editedCampLocation}} -->
    <div class="row">

        <div class="col">
            <div class="mb-12">

            <TextInputVue input-id="campNameInput" label-text="Camp Location Name:" :input-v-model="this.editedCampLocation.campName" object-key="campName" @update-form="UpdateForm" @blur="v$.editedCampLocation.campName.$touch" :my-errors="v$.editedCampLocation.campName.$errors"></TextInputVue>
            </div>
        </div>

    </div>

    <div class="row">

        <div class="col">
            <div class="mb-12">

                <DropdownInputVue input-id="countryId" label-text="Country:" :input-v-model="editedCampLocation.countryId" object-key="countryId" :option-list="this.countryDropdownValues" @update-form="UpdateForm" @blur="v$.editedCampLocation.countryId.$touch" :my-errors="v$.editedCampLocation.countryId.$errors"  aria-label="Select Country"></DropdownInputVue>

            </div>
        </div>

    </div>

    <div class="row">

        <div class="col">
            <div class="mb-12">

                <RadioBoolInputVue input-id="flexRadioDefault" label-text="Active:" :input-v-model="editedCampLocation.isActive" object-key="isActive" bool-true-text="Active" bool-false-text="Inactive" @update-form="UpdateForm" @blur="v$.editedCampLocation.isActive.$touch" :my-errors="v$.editedCampLocation.isActive.$errors"></RadioBoolInputVue>

            </div>
        </div>

    </div>

    <div class="row" v-if="(editedCampLocation.updateDate != null)">

        <div class="col">
            <div class="mb-12">

                <label :for="updateDate" class="form-label">Last Updated:</label>
                <span id="updateDate" class="displayDate">{{this.editedCampLocation.updateDatePretty}}</span>
            </div>
        </div>

    </div>
</form>

</template>

<script> 

import { store } from "@/store/store.js";
import $ from "jquery";
import { useVuelidate } from '@vuelidate/core'
import { ajaxGetAndReturn } from "@/components/helpers/utilities";
import TextInputVue from "@/components/formComponents/TextInput.vue";
import DropdownInputVue from "@/components/formComponents/DropdownInput.vue";
import RadioBoolInputVue from "@/components/formComponents/RadioBoolInput.vue";
import { required, minValue, helpers} from '@vuelidate/validators'; 

export default {
  name: "ContractForm",
  components: {
  TextInputVue, DropdownInputVue,RadioBoolInputVue
  }, 
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
      return {
        buttonText: "Save New Camp Location",
        successMessage: "",
        notSubmitted:true,
        editedCampLocation:{},
        countryDropdownValues: []
      };
    },
    props: {
        loadedCampLocation:Object,
    },
    watch:{
        loadedCampLocation(newVal,oldVal){

            oldVal;
            this.editedCampLocation.campName = newVal.campName; 
        }
    },
     created() {
        this.editedCampLocation.isActive = null; 
        this.editedCampLocation = this.loadedCampLocation;
        
        this.buttonText = "Save Changes to Camp Location";

        ajaxGetAndReturn(store.webAPIUrl + "Countries/getDropdown", (result) =>{
            this.countryDropdownValues = result; 
        });
    },
    methods:{
        UpdateForm(objKey, modelData){

            this.editedCampLocation[objKey] = modelData;
        },
        async Submit(){

            const isFormCorrect = await this.v$.$validate();
            // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
            if (!isFormCorrect) return;

            var method = "POST";
            var actionUrl = store.webAPIUrl + "CampLocations"; 

            this.editedCampLocation.createDate = new Date();
            this.editedCampLocation.updateDate = new Date();

            if(this.editedCampLocation.campLocationId != null && this.editedCampLocation.campLocationId != 0){
                method = "PUT";
                actionUrl += "/" + this.editedCampLocation.campLocationId;
            }

            $.ajax({
                method: method,
                data: JSON.stringify(this.editedCampLocation),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: actionUrl,
                success: (result) => {

                    var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                    console.log(successMessage);
                    this.$emit("CampLocationFormSubmitted");
                },
            });

            console.log("hit submit camp location form");
        }
    },
     validations () {
        return {
            editedCampLocation:{
                campName: {
                    required:helpers.withMessage("Camp Name is Required", required)
                },
                isActive:{
                    required: helpers.withMessage("Active is Required.", required)
                },
                countryId: {
                    minValue: helpers.withMessage("Country is Required", minValue(1))
              },
            }
        }
    },

}
</script>

<style>
.lucasForm{
    width:100%;
    display:flex;
    flex-wrap:wrap;
    justify-content:space-around;
}
.formElement{
    flex-basis:40%;
    margin-right:15px;
    margin-top:15px;
}
    .errorMessageForm {
        color: #DC143C;
        font-size: 12px;
        text-align: left;
    }
.form-label{
    font-weight: bold;
    font-size: 14px;
    float: left;
}
#successMessage{
    display: flex;
    font-size: 12px;
    color: green;
}
.displayDate{
    display: inline-block;
    width:100%;
    text-align: left;
}

</style>